export enum FontsEnum {
    RUBIK_400_REGULAR = 'Rubik_400Regular',
    RUBIK_500_MEDIUM = 'Rubik_500Medium',
    RUBIK_700_BOLD = 'Rubik_700Bold',
}
